<app-review-form-header>
  <div title>
    <span class="text-xl font-bold">Validation</span>
    <span class="text-sm text-gray-500 ml-2">{{ assignmentType() }}</span>
  </div>
  <div actions class="flex items-center gap-2">
    <app-pan-button color="primary" icon="arrow_back" (click)="goToDashboard()">Back</app-pan-button>

    <app-pan-button
      color="primary"
      icon="search"
      (click)="reviewModal.show()"
      [state]="isSubmitting() ? 'loading' : 'default'"
      [disabled]="isSubmitting()"
      data-testid="validateReview"
    >
      Validate Review
    </app-pan-button>

    <app-review-report-problem [reviewId]="currentValidationId()"></app-review-report-problem>

    <app-video-password-actions
      [reviewId]="currentValidationId()"
      [passwordAction]="rhombusPasswordOptOut() ? 'clear' : 'refresh'"
    ></app-video-password-actions>

    @if (investigationId()) {
      <app-review-timer [reviewId]="currentValidationId()" [disableExpiredModal]="true"></app-review-timer>
    }
  </div>
</app-review-form-header>

<app-pan-modal [shouldBodyScroll]="true" #reviewModal [topLevel]="false" size="lg">
  <div header>Submit validation</div>

  <div body>
    @if (incidentFormRef()) {
      <ng-container [ngTemplateOutlet]="incidentFormRef()"></ng-container>
    }

    @if (validationForm) {
      <div [formGroup]="validationForm">
        <app-pan-form-control>
          <app-pan-floating-label for="commentsRating" [required]="true">Rate Comments</app-pan-floating-label>
          <app-pan-star-rating
            size="lg"
            [rating]="validationForm.controls.commentsRating.value"
            (ratingChange)="onRatingChange($event)"
          ></app-pan-star-rating>
        </app-pan-form-control>
      </div>
    }

    @if (validationForm?.controls.commentsRating.hasError("required")) {
      <app-pan-inline-alert type="danger" class="mb-2">Comment rating is required</app-pan-inline-alert>
    }

    <swal
      #submittedSwal
      title="Incident submitted 🎉"
      text="Thank you for the validation!"
      icon="success"
      [showConfirmButton]="false"
      [showDenyButton]="true"
      [focusCancel]="true"
      denyButtonText="Back to dashboard"
      denyButtonColor="gray"
      (deny)="goToDashboard()"
    ></swal>
    <app-review-submission-failed-modal #failedModal [errorMessage]="submitErrorMessage()"></app-review-submission-failed-modal>
  </div>

  <div footer class="flex items-center">
    <app-pan-button
      panModalClose
      color="primary"
      (click)="submitValidation(false)"
      [disabled]="isSubmitting() || !reviewFormService.isFormSubmittable()"
      [state]="isSubmitting() ? 'loading' : 'default'"
      data-testid="submitReview"
    >
      Submit
    </app-pan-button>
    <app-pan-button panModalClose>Cancel</app-pan-button>
    <app-pan-button
      panModalClose
      icon="check"
      color="success"
      (click)="submitValidation(true)"
      [disabled]="isSubmitting() || !reviewFormService.isFormSubmittable()"
      [state]="isSubmitting() ? 'loading' : 'default'"
      data-testid="noChanges"
    >
      No changes
    </app-pan-button>
  </div>
</app-pan-modal>

@if (isCompleted()) {
  <app-pan-inline-alert type="info" class="m-2"> This assignment has already been completed.</app-pan-inline-alert>
}

@let investigation = assignmentDetailsStore.details();
@if (investigation?.email && investigation?.completed_at) {
  <app-pan-inline-alert type="success" class="my-2">
    This assignment was completed by <b>{{ investigation.email }}</b> on {{ investigation.completed_at | date: "medium" }}.
  </app-pan-inline-alert>
}
<!-- we load the original investigation assignment first (async) -->
@if (investigationId()) {
  @switch (assignmentType()) {
    @case (ReviewSubjectType.Cancellation) {
      <app-transaction-incident-form
        [incidentDateEditable]="true"
        [locationTimezone]="locationTimezone()"
        (contextReady)="onContextReady($event)"
        (formRefReady)="incidentFormRef.set($event)"
      />
    }
    @case (ReviewSubjectType.Underringing) {
      <app-transaction-incident-form
        [incidentDateEditable]="true"
        [locationTimezone]="locationTimezone()"
        (contextReady)="onContextReady($event)"
        (formRefReady)="incidentFormRef.set($event)"
      />
    }
    @case (ReviewSubjectType.Sideloaded) {
      <app-sideloaded-incident-form
        [locationTimezone]="locationTimezone()"
        (contextReady)="onContextReady($event)"
        (formRefReady)="incidentFormRef.set($event)"
      />
    }
    @case (ReviewSubjectType.Deepdive) {
      <app-sideloaded-incident-form
        [locationTimezone]="locationTimezone()"
        (contextReady)="onContextReady($event)"
        (formRefReady)="incidentFormRef.set($event)"
      />
    }
    @case (ReviewSubjectType.Walkout) {
      <app-walkout-incident-form
        [incidentDateEditable]="true"
        [locationTimezone]="locationTimezone()"
        (contextReady)="onContextReady($event)"
        (formRefReady)="incidentFormRef.set($event)"
      />
    }
  }

  <div class="flex flex-row justify-end max-xl:flex-col">
    <div class="basis-1/2 p-4 gap-8">
      <app-pan-card header="Review ID" subheader="This is the ID of the review you are validating.">
        <app-pan-form-control class="flex-1">
          <app-pan-floating-label>Review ID</app-pan-floating-label>
          <input panInput readonly [value]="investigationId()" />
        </app-pan-form-control>
      </app-pan-card>
    </div>
  </div>
}
